// extracted by mini-css-extract-plugin
export default {"tooltip":"To-z","sharingV2":"Uo-z","sharingIconsV2":"Vo-z","links":"Wo-z","link":"Xo-z","facebookV2":"Yo-z","twitterV2":"Zo-z","pinterestV2":"_o-z"};